/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('global/OrderHelper',[
    'lodash',
    './Logger'
], function (_, Logger) {
    'use strict';

    /**
     * Function calculates margin value for each order item
     * @param {any} order
     */
    function setOrderMargins(order) {
        setOrderItemsMargins(order.items);
        _.each(order.recipients,
            function (recipient) {
                setOrderItemsMargins(recipient.items);
            });
    }

    function setOrderItemsMargins(orderItems) {
        _.each(orderItems,
            function (orderItem) {
                if (_.isUndefined(orderItem.product) || _.isUndefined(orderItem.product.customFields)) {
                    orderItem.margin = 0;
                    return;
                } else {
                    var productCostAtts = orderItem.product.customFields["cost"];
                    if (productCostAtts && _.some(productCostAtts)) {
                        orderItem.cost = _.first(productCostAtts).value;
                    }
                    orderItem.margin = (((orderItem.price - orderItem.cost) / orderItem.price) * 100).toFixed(2);
                }
            });
    }

    var OrderHelper = {
        setOrderMargins: setOrderMargins
    };

    Logger.debug('OrderHelper.js Loaded:', OrderHelper);

    return OrderHelper;
});
